import { Component, OnInit } from '@angular/core';
import { EmployeeDashboardService } from '../../services/eb-enrollee-dashboard/enrollee-dashboard.service';
import { LatestClaimStatus } from 'src/app/utility/enum/global-enum';
import { DashboardVm } from '../../models/dashboard-vm';
import { NavigateService } from 'src/app/utility/services/navigate/navigate.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './eb-enrollee-dashboard.component.html',
  styleUrls: ['./eb-enrollee-dashboard.component.scss']
})
export class EBEnrolleeDashboardComponent implements OnInit {

  constructor(
    private employeeDashboardService: EmployeeDashboardService,
    private navigateService: NavigateService,
  ) { }

  LatestClaimStatus = LatestClaimStatus;
  seeAllProduct: boolean = false;

  ngOnInit() {
    this.getDashboardData();
  }

  dashboardData: DashboardVm;

  getDashboardData() {
    this.employeeDashboardService.getByEmail().subscribe(
      (res: any) => {
        this.dashboardData = res;
      }
    )
  }

  viewMore() {
    this.navigateService.toClaimHistory();
  }

  createNewClaim() {
    this.navigateService.toClaimSubmission();
  }
}








